import { Component, OnInit } from "@angular/core";
import { RetrofitService } from "../../../services/retrofit.service";
import * as moment from "moment";

@Component({
  selector: "app-final-pdf-report",
  templateUrl: "./final-pdf-report.component.html",
  styleUrls: ["./final-pdf-report.component.css"],
})
export class FinalPdfReportComponent implements OnInit {
  constructor(private retrofitService: RetrofitService) {}

  otoImage = "assets/img/retrofit/retrofit_logo.png";
  exponentImage = "assets/img/epack-pdf-report/exponent_logo.png";

  data: {
    page1: {
      testReport: {
        label: string;
        value: string;
        signal: string;
      }[];
      comprehensiveReport: {
        label: string;
        value: string;
        signal: string;
      }[];
    };
    page2: {
      preload: { result: string; unit: string; test_name: string }[];
      postload: { result: string; unit: string; test_name: string }[];
    };
    page3: {
      fastCharge: { result: string; unit: string; test_name: string }[];
      onRoad: { result: string; unit: string; test_name: string }[];
    };
  } = {
    page1: { comprehensiveReport: [], testReport: [] },
    page2: { preload: [], postload: [] },
    page3: { fastCharge: [], onRoad: [] },
  };
  ngOnInit(): void {}

  private async getFinalReportData(testId: string) {
    const testReportKeys = {
      test_id: "Test ID",
      test_date: "Test Date",
      vehicle_number: "Vehicle number",
      pkn_id: "PKN ID",
      front_pack_id: "Front Battery Unique ID",
      rear_pack_id: "Rear Battery Unique ID",
      front_bms_id: "Front BMS Unique ID",
      rear_bms_id: "Rear BMS Unique ID",
      bytebeam_id: "Bytebeam ID",
      // "Motor ID serial number",
      eport_number: "E^port ID",
      motor_controller_number: "Motor controller serial number",
      // "EOl Results",
    };

    const testSummaryKeys = {
      final_eol_result: "Final EOL Result",
      "pre-load": "Pre Load",
      "post-load": "Post Load",
      "fast-charge": "Fast Charge",
      "on-road": "On Road",
    };

    this.retrofitService.getFinalReportData(testId).subscribe({
      next: (res) => {
        if (res.status === 200) {
          const { data } = res.body;

          const testReportData = [];
          const summaryData = [];

          Object.keys(testReportKeys).forEach((_) => {
            let label = testReportKeys[_];
            let value = data.test_data[_];
            let signal = _;

            if (signal === "test_date") {
              value = moment(new Date(value)).format("DD-MM-YYYY");
            }

            testReportData.push({ label, value, signal });
          });

          Object.keys(testSummaryKeys).forEach((_) => {
            summaryData.push({
              label: testSummaryKeys[_],
              value: data.summary_results[_],
              signal: _,
            });
          });

          this.data.page1.testReport = testReportData;
          this.data.page1.comprehensiveReport = summaryData;

          this.data.page2.preload = data["pre-load"];
          this.data.page2.postload = data["post-load"];

          this.data.page3.fastCharge = data["fast-charge"];
          this.data.page3.onRoad = data["on-road"];
          setTimeout(() => {
            this.renderPdf();
          }, 500);
        }
      },
    });

    return true;
  }

  private renderPdf() {
    const reportElement = document.getElementById(
      "reportContainer",
    ) as HTMLDivElement;

    // Wait for all images to fully load before generating the PDF
    const images = Array.from(reportElement.querySelectorAll("img"));

    Promise.all(
      images.map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      }),
    ).then(() => {
      const pdfWidth = reportElement.clientWidth;
      const pdfHeight = reportElement.clientHeight;

      const docWindow: any = window;
      const { jsPDF } = docWindow.jspdf;

      const doc = new jsPDF({
        unit: "px",
        format: [pdfWidth, pdfHeight],
      });

      doc.html(reportElement, {
        html2canvas: { useCORS: true, allowTaint: true },
        width: pdfWidth,
        windowWidth: pdfWidth,
        callback: () => {
          const totalPages = doc.getNumberOfPages();
          for (let i = totalPages; i > 1; i--) {
            doc.deletePage(i);
          }
          const pdfBlob = doc.output("blob");
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl, "_blank");
        },
      });
    });
  }

  generatePdfDocument(testId: string) {
    this.getFinalReportData(testId);
  }
}
